import {observable, action} from 'mobx';
import intl from 'react-intl-universal';
import enUS from '../locale/en';
import zhCN from '../locale/zh_CN';
import moment from 'moment';

const getLocaleMessages = (name)=>{
    switch (name){
        case 'en-US':return enUS;
        case 'zh-CN':return zhCN;
        default:
            return zhCN;
    }
}

export default class LocaleStore {
    constructor(rootStore) {
        this.rootStore = rootStore;
        //console.log(moment.locale(),'4444')
        var local = window.localStorage.getItem('lang');
        this.setLocale(local)
    }

    @observable locale = '';//'en-US';//'zh-CN';
    @observable initDone = false;

    @action
    setLocale(locale) {
        //如果已经切换成当前语言了就不需要重新切换了
        console.log(locale,this.locale);
        if (locale === this.locale) {
            return;
        }
        this.locale = locale || 'zh-CN';
        window.localStorage.setItem('lang', this.locale);
        this.initDone = false;
        this.loadLocales();
        moment.locale(this.locale);
    }

    @action
    loadLocales() {
        const {locale} = this;
        // init method will load CLDR locale data according to currentLocale
        // react-intl-universal is singleton, so you should init it only once in your app
        intl.init({
            currentLocale: locale, // en/en-US
            locales:{
                [locale]:getLocaleMessages(locale)
            },
            commonLocaleDataUrls:{
                en: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/en.js",
                zh: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/zh.js",
                fr: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/fr.js",
                fa: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/fa.js",
                ja: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/ja.js",
                de: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/de.js",
                es: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/es.js",
                ko: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/ko.js",
                pt: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/pt.js",
                it: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/it.js",
                ru: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/ru.js",
                pl: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/pl.js",
                nl: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/nl.js",
                sv: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/sv.js",
                tr: "//image1.jfoto.cn/npm/react-intl-universal/locale-data/1.0.0/tr.js"
            }
        }).then(action(() => {
                // After loading CLDR locale data, start to render
                this.initDone = true;

        }));
    }
}



// WEBPACK FOOTER //
// ./src/store/LocaleStore.js